module.exports = {"pt-BR":{"components":{"unauthorized":{"message":"Volte uma casa... Você não possui permissão para acessar esta página."}}}}